import z from 'zod';
import {quizTimedModeSchema} from './QuizTimedMode';

/** Initial write from client; trigger then populates module details and questions. */
export const quizSessionWriteSchema = z.object({
  moduleId: z.string(),
  topics: z.array(z.string()),
  difficulty: z.number().optional(),
  count: z.number().optional().default(10),
  timedMode: quizTimedModeSchema,
  timeDurationSeconds: z.number().optional(),
});

export interface QuizSessionWrite extends z.infer<typeof quizSessionWriteSchema> {}
